{
  "INBOX": {
    "LIST": {
      "404": "There are no active notifications in this group.",
      "TITLE": "My Inbox",
      "DISPLAY_DROPDOWN": "Display",
      "LOADING": "Fetching notifications",
      "NO_NOTIFICATIONS": "No notifications",
      "NOTE": "Notifications from all subscribed inboxes",
      "NO_MESSAGES_AVAILABLE": "Oops! Not able to fetch messages",
      "SNOOZED_UNTIL": "Snoozed until",
      "SNOOZED_UNTIL_TOMORROW": "Posticipato fino a domani",
      "SNOOZED_UNTIL_NEXT_WEEK": "Posticipato fino alla prossima settimana"
    },
    "ACTION_HEADER": {
      "SNOOZE": "Snooze notification",
      "DELETE": "Delete notification",
      "BACK": "Indietro"
    },
    "TYPES": {
      "CONVERSATION_MENTION": "You have been mentioned in a conversation",
      "CONVERSATION_CREATION": "New conversation created",
      "CONVERSATION_ASSIGNMENT": "A conversation has been assigned to you",
      "ASSIGNED_CONVERSATION_NEW_MESSAGE": "New message in an assigned conversation",
      "PARTICIPATING_CONVERSATION_NEW_MESSAGE": "New message in a conversation you are participating in",
      "SLA_MISSED_FIRST_RESPONSE": "SLA target first response missed for conversation",
      "SLA_MISSED_NEXT_RESPONSE": "SLA target next response missed for conversation",
      "SLA_MISSED_RESOLUTION": "SLA target resolution missed for conversation"
    },
    "TYPES_NEXT": {
      "CONVERSATION_MENTION": "Mentioned",
      "CONVERSATION_ASSIGNMENT": "Assigned to you",
      "CONVERSATION_CREATION": "New Conversation",
      "SLA_MISSED_FIRST_RESPONSE": "SLA breach",
      "SLA_MISSED_NEXT_RESPONSE": "SLA breach",
      "SLA_MISSED_RESOLUTION": "SLA breach",
      "PARTICIPATING_CONVERSATION_NEW_MESSAGE": "Nuovo messaggio",
      "ASSIGNED_CONVERSATION_NEW_MESSAGE": "Nuovo messaggio",
      "SNOOZED_UNTIL": "Snoozed for {time}",
      "SNOOZED_ENDS": "Snooze ended",
      "UNASSIGNED_CONVERSATION_NEW_MESSAGE": "Nuovo messaggio"
    },
    "NO_CONTENT": "Nessun contenuto disponibile",
    "PHONE_CALL_TYPES": {
      "OUTBOUND_CONNECTED": "Chiamata in uscita - Connessa",
      "OUTBOUND_FAILED": "Chiamata in uscita - Fallita",
      "INBOUND_MISSED": "Chiamata in entrata - Persa",
      "INBOUND_UNANSWERED_MISSED": "Chiamata in entrata - Persa senza risposta",
      "INBOUND_AGENT": "Chiamata in entrata - Risposta da agente",
      "INBOUND_IVR": "Chiamata in entrata - Risposta da IVR",
      "DEFAULT": "Chiamata telefonica"
    },
    "MENU_ITEM": {
      "MARK_AS_READ": "Segna come letto",
      "MARK_AS_UNREAD": "Segna come non letto",
      "SNOOZE": "Posticipa",
      "DELETE": "Elimina",
      "MARK_ALL_READ": "Segna tutto come letto",
      "DELETE_ALL": "Delete all",
      "DELETE_ALL_READ": "Delete all read"
    },
    "DISPLAY_MENU": {
      "SORT": "Sort",
      "DISPLAY": "Display :",
      "SORT_OPTIONS": {
        "NEWEST": "Newest",
        "OLDEST": "Oldest",
        "PRIORITY": "Priorità"
      },
      "DISPLAY_OPTIONS": {
        "SNOOZED": "Posticipato",
        "READ": "Leggi",
        "LABELS": "Etichette",
        "CONVERSATION_ID": "Conversation ID"
      }
    },
    "ALERTS": {
      "MARK_AS_READ": "Notification marked as read",
      "MARK_AS_UNREAD": "Notification marked as unread",
      "SNOOZE": "Notification snoozed",
      "DELETE": "Notification deleted",
      "MARK_ALL_READ": "All notifications marked as read",
      "DELETE_ALL": "All notifications deleted",
      "DELETE_ALL_READ": "All read notifications deleted"
    }
  }
}
